import React from 'react';

import clsx from 'classnames';
import PropTypes from 'prop-types';

import {
    Section,
    Typography,
} from 'wanderu-components';

import styles from './LinkSection.scss';

function LinkSection(props) {
    const {
        className,
        children,
        title,
    } = props;

    return (
        <Section className={clsx(styles.section, className)}>
            {title && (
                <Typography
                    className={styles.title}
                    component="h2"
                    variant="h3"
                >
                    {title}
                </Typography>
            )}
            {children}
        </Section>
    );
}

LinkSection.propTypes = {
    title: PropTypes.string,
    className: PropTypes.string,
};

export { LinkSection };
export default LinkSection;
